import React from 'react';
import { map } from 'lodash';
import { OverlayTrigger, Popover, FormCheck, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { FilterType, useFilterContext } from '../FilterProvider';
import { CarPlanTypes } from '@models/CarPlan';

type Item = keyof Pick<FilterType, 'accidentToDriver' | 'passengerLiability' | 'flood' | 'srcc'>;

const items: Item[] = ['accidentToDriver', 'passengerLiability', 'flood', 'srcc'];

const FilterAddonCover = () => {
  const { t } = useTranslation();
  const { filters, updateFilters } = useFilterContext();
  const isTpl = filters.planType === CarPlanTypes.ThirdParty;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    updateFilters({ [name]: checked });
  };

  return (
    <div className="py-2 ms-3">
      <div className="py-1">
        <span className="pe-1 fw-bold">{t('carInsuranceQuote.addons')}</span>
      </div>
      <Stack direction="horizontal" gap={2} className="mt-2">
        {map(items, (item) => (
          <FormCheck
            key={item}
            id={item}
            name={item}
            value={filters[item].toString()}
            checked={filters[item]}
            onChange={handleChange}
            disabled={isTpl && (item === 'flood' || item === 'srcc')}
            label={
              <>
                <span className="me-1">{t(`carInsuranceQuote.${item}.name`)}</span>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Popover>
                      <Popover.Body>{t(`carInsuranceQuote.${item}.description`)}</Popover.Body>
                    </Popover>
                  }
                >
                  <FontAwesomeIcon icon={faCircleInfo} size="sm" />
                </OverlayTrigger>
              </>
            }
          />
        ))}
      </Stack>
    </div>
  );
};

export { FilterAddonCover };
